import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { useContactForm } from '@/components_new/ContactForm/use-contact-form'
import ContactForm from '@/components_new/ContactForm/ContactForm.vue'
import ModalContainer from '@/components_new/ModalItems/ModalContainer.vue'
import BugImg from '@/components_new/ModalItems/images/bug.webp'


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalReportBug',
  props: {
    isOpen: { type: Boolean },
    page: {}
  },
  emits: ["closeReportModal"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const additionalRequestParamsRef = computed(() => ({ page: props.page }))

const closeModal = () => emit('closeReportModal')

const { formData, submitStatus, resetForm, handleSubmit } = useContactForm({
    additionalRequestParamsRef,
    onSuccessAnimationFinished: closeModal,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalContainer, {
    title: _ctx.$tr('modalReportBug.title'),
    description: _ctx.$tr('modalReportBug.description'),
    image: _unref(BugImg),
    alt: _ctx.$tr('modalReportBug.alt'),
    isOpened: _ctx.isOpen,
    class: _normalizeClass(_ctx.$style.dialog_report),
    onCloseModal: closeModal
  }, {
    "custom-content": _withCtx(() => [
      _createVNode(ContactForm, {
        modelValue: _unref(formData),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(formData) ? (formData).value = $event : null)),
        viewMode: "modal",
        submitStatus: _unref(submitStatus),
        onFormReset: _unref(resetForm),
        onSubmit: _unref(handleSubmit)
      }, null, 8, ["modelValue", "submitStatus", "onFormReset", "onSubmit"])
    ]),
    _: 1
  }, 8, ["title", "description", "image", "alt", "isOpened", "class"]))
}
}

})